export default __webpack_public_path__ + "static/media/sqfamily22-image-asq.2602bad6.jpg";